import { render, staticRenderFns } from "./CAppTelephoneButton.vue?vue&type=template&id=517549d0&scoped=true&"
import script from "./CAppTelephoneButton.vue?vue&type=script&lang=ts&"
export * from "./CAppTelephoneButton.vue?vue&type=script&lang=ts&"
import style0 from "./CAppTelephoneButton.vue?vue&type=style&index=0&id=517549d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517549d0",
  null
  
)

export default component.exports